/** Parses `GET CustomerTask/today/count` JSON (plain number or wrapper). */
export function normalizeTodayTasksCountPayload(payload: unknown): number | null {
  if (payload == null) {
    return null;
  }
  if (typeof payload === 'number' && !Number.isNaN(payload)) {
    return Math.max(0, Math.floor(payload));
  }
  if (typeof payload === 'string') {
    const n = parseInt(payload, 10);
    return Number.isNaN(n) ? null : Math.max(0, n);
  }
  const o = payload as Record<string, unknown>;
  const v = o['count'] ?? o['total'] ?? o['value'];
  if (typeof v === 'number' && !Number.isNaN(v)) {
    return Math.max(0, Math.floor(v));
  }
  if (typeof v === 'string') {
    const n = parseInt(v, 10);
    return Number.isNaN(n) ? null : Math.max(0, n);
  }
  return null;
}
